var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',[_c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-page__type"},[_vm._v("404")]),_c('div',{staticClass:"error-page__text"},[_vm._v("Страница не найдена!")]),_c('div',[_c('FormButton',{on:{"click":function($event){return _vm.$router.push({ name: 'home' })}}},[_vm._v(" К витрине ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }